import { Typography } from "@mui/material";
import styled from "styled-components";

export const SwitchContainer = styled.div<{
  isActive: boolean;
  editMode: boolean;
}>`
  z-index: 10;
  border: 1px solid
    ${({ isActive, theme }) =>
      isActive ? theme.palette.success.main : theme.palette.error.main};
  border-radius: 25px;
  align-items: center;
  display: flex;
  margin-left: 15px;
  padding: ${({ editMode }) =>
    editMode ? "5px 5px 5px 15px" : "5px 15px 5px 15px"};
`;

export const IsActiveText = styled(Typography)<{ isActive: boolean }>`
  color: ${({ isActive, theme }) =>
    isActive ? theme.palette.success.main : theme.palette.error.main};
  min-width: 49px;
  text-align: center;
`;

export const ContainerTitle = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 10px 50px 10px 0;
`;
